import {t} from 'i18next'
import moment from 'moment'

import { customStyles, displayDate, isNull } from '../../../izUtils'

// The head row is coloured too, so the empty cell above the expand toggles matches the rest of the header
export const importTableStyles = {
    ...customStyles,
    headRow: {
        style: {
            backgroundColor: 'var(--theme-secondary)',
        },
    },
};

export const displayValue = (value) => {
    if (isNull(value) || value === '') return '—';
    if (value === true) return t('contracts.import.yes');
    if (value === false) return t('contracts.import.no');
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}( \d{2}:\d{2}:\d{2})?$/.test(value)) return displayDate(moment.utc(value), 'date');
    return String(value);
}

export const fieldName = (field) => t('contracts.import.fields.' + field, {defaultValue: field});

export const fieldValue = (field, value) => field === 'billing_method' ? t('contracts.import.billing.' + value, {defaultValue: value}) : displayValue(value);

export const entityName = (entity) => t('contracts.import.entities.' + entity, {defaultValue: entity});

export const WarningList = ({warnings}) => warnings.map((warning, index) => (
    <div key={'warning-' + index} className={'mb-1 ' + (warning.level === 'review' ? 'text-danger' : 'text-muted')}>
        <i className={'fa me-1 ' + (warning.level === 'review' ? 'fa-exclamation-triangle' : 'fa-info-circle')}></i>{warning.message}
    </div>
))
